import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import VueAnalytics from 'vue-analytics'

import Home from '@/views/home/Home'
import About from '@/views/home/About'
import Contact from '@/views/home/Contact'

import Doctors from '@/views/directory/Doctors'
import DoctorDetail from '@/views/directory/Doctor'

import Hospitals from '@/views/directory/Hospitals'
import Signup from '@/views/Signup'
import Signin from '@/views/Signin'
import Tos from '@/views/home/Tos'
import Privacy from '@/views/home/Privacy'

/* Offices */
import OfficesIndex from '@/views/offices/Index'
import OfficesShow from '@/views/offices/Show'
import OfficesNew from '@/views/offices/New'

import store from '@/store'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/signup', name: 'Signup', component: Signup },
  { path: '/signin', name: 'Signin', component: Signin },
  { path: '/about', name: 'About', component: About },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/doctors', name: 'Doctors', component: Doctors },
  { path: '/doctors/:id', name: 'Doctor', component: DoctorDetail },
  { path: '/hospitals', name: 'Hospitals', component: Hospitals },
  { path: '/privacy', name: 'Privacy', component: Privacy },
  { path: '/tos', name: 'Tos', component: Tos },
  { path: '/offices', name: 'OfficesIndex', component: OfficesIndex, meta: { requireAuth: false } },
  { path: '/offices/new', name: 'Offices', component: OfficesNew, meta: { requireAuth: true } },
  { path: '/offices/:id', name: 'OfficesShow', component: OfficesShow, meta: { requireAuth: true } }

]

Vue.use(VueRouter)
Vue.use(Meta)

const router = new VueRouter({ routes, mode: 'history', base: '/' })

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS,
  checkDuplicatedScript: true,
  router
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth && store.state.doctor === null) {
    next('/signin')
  } else {
    next()
  }
})

export default router
